import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-right-sidebar',
  templateUrl: './blog-details-right-sidebar.component.html',
  styleUrls: ['./blog-details-right-sidebar.component.css']
})
export class BlogDetailsRightSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
